const ToggleAnime = require('../velocity/toggle-anime');

/**
 * Select
 * @class
 */
class Select {

  /**
   * @static
   * @return {object} default options
   */
  static get defOpts() {
    return {
      elms: {
        pulldownClass: 'js-select-pulldown',
        cntClass     : 'js-select-cnt',
      },
    }
  };

  /**
   * @instance
   * @param _$el {HTMLElement}
   * @param _opts {object}
   */
  constructor(_$el, opts = {}) {
    const { elms } = _.defaultsDeep(opts, Select.defOpts);

    this.$pulldown = _$el.getElementsByClassName(elms.pulldownClass)[0];
    this.$$cnt     = _$el.getElementsByClassName(elms.cntClass);

    this.cntElms = _.reduce(this.$$cnt, (_memo, _$cnt) => {
      _memo[_$cnt.dataset.selectId] = _$cnt;
      return _memo;
    }, {});

    this.changeEvent = new CustomEvent('change');
    this.currentId   = this.$pulldown.value;

    window.addEventListener('hashchange', this.hashchange.bind(this), false);
    this.$pulldown.addEventListener('change', this.update.bind(this), false);

    this.hashchange(true);
  }

  /**
   * @instance
   * @private
   * @param _isFirst {boolean}
   */
  hashchange(_isFirst = false) {
    const hash_ = location.hash.replace('#', '');

    if(hash_ && this.cntElms[hash_]) {
      this.$pulldown.value = hash_;
      this.$pulldown.dispatchEvent(this.changeEvent);
      this.change(hash_, this.currentId);
    }
    else if(_isFirst) {
      const val_ = this.$pulldown.value;
      this.change(val_, this.currentId);
    }
  }

  /**
   * @instance
   * @private
   */
  update() {
    location.hash = `#${ this.$pulldown.value }`;
  }

  /**
   * @instance
   * @private
   * @param _targetId {string}
   * @param _currentId {string}
   */
  change(_targetId, _currentId = null) {
    if(_currentId) {
      this.cntElms[_currentId].style.display = 'none';
    }
    this.cntElms[_targetId].style.display = 'block';

    this.currentId = _targetId;
  }

}

/**
 * class exports
 */
module.exports = Select;



/** WEBPACK FOOTER **
 ** ./webpack/requires/view/ui/select.js
 **/